import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.js';
import { PublicClientApplication, EventType } from '@azure/msal-browser';
import { msalConfig } from './authConfig.js';

import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';

const authEnabled = process.env.REACT_APP_AUTH_ENABLED !== 'false';
let msalInstance = null;

if (!authEnabled) {
    const root = createRoot(document.getElementById('root'));
    root.render(<App instance={msalInstance}/>);
} else {
    msalInstance = new PublicClientApplication(msalConfig);
    
    msalInstance.initialize().then(() => {
        // Default to using the first account if no account is active on page load
        if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
            msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
        }

        // Handle redirect promise
        msalInstance.handleRedirectPromise().catch((error) => {
            console.error('Redirect handling failed:', error);
        });

        // Listen for sign-in event and set active account
        msalInstance.addEventCallback((event) => {
            if (event.eventType === EventType.LOGIN_SUCCESS && event.payload.account) {
                const account = event.payload.account;
                msalInstance.setActiveAccount(account);
            }
        });
        
        const root = createRoot(document.getElementById('root'));
        root.render(<App instance={msalInstance}/>);
    }).catch((error) => {
        console.error('MSAL initialization failed:', error);
    });
}
